// MUI Imports
import type { Theme } from '@mui/material/styles';
import { padding } from '@mui/system';

const formControlLabel: Theme['components'] = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        marginInlineStart: theme.spacing(-2),
        '&.radio-boxed': {
          border: '1px solid',
          borderColor: theme.palette.divider,
          borderRadius: '6px',
          paddingBlock: theme.spacing(1),
          paddingInline: theme.spacing(2),
        },
      }),
      label: {
        '&, &.Mui-disabled': {
          color: 'var(--mui-palette-text-primary)',
        },
        '&.Mui-disabled': {
          opacity: 0.45,
        },
      },
    },
  },
};

export default formControlLabel;
